<div class="container" *ngIf="pages > 0">
    <div class="page {{num === activePage ? 'page--active' : ''}}
        {{!!num ? 'page--clickable' : ''}}" *ngFor="let num of getPages()"
        (click)="pageSelected(num)">
            {{num ? num : '...'}}
    </div>
</div>
